import { QueryClient as e, QueryClientProvider as t } from "@tanstack/react-query";
//#region src/client/ApiClient.ts
function n(e) {
	if (e && typeof e == "object" && "status" in e) {
		let t = e.status;
		return t >= 400 && t < 500;
	}
	return !1;
}
var r = (e, t) => !n(t), i = class extends e {
	constructor(e) {
		super({
			...e,
			defaultOptions: {
				...e?.defaultOptions,
				queries: {
					retry: r,
					...e?.defaultOptions?.queries
				},
				mutations: {
					retry: r,
					...e?.defaultOptions?.mutations
				}
			}
		});
	}
}, a = t;
//#endregion
export { i as ApiClient, a as ReactQueryProvider };
